import { useEffect, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Génère un ID de session unique (stocké dans sessionStorage)
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('tracking_session_id');
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('tracking_session_id', sessionId);
  }
  return sessionId;
};

// Génère un ID anonyme (stocké dans localStorage)
const getAnonId = () => {
  let anonId = localStorage.getItem('tracking_anon_id');
  if (!anonId) {
    anonId = `anon_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('tracking_anon_id', anonId);
  }
  return anonId;
};

export const useTracking = () => {
  // Track page view automatiquement
  const trackPageView = useCallback((pageName) => {
    const sessionId = getSessionId();
    const anonId = getAnonId();
    
    fetch(`${BACKEND_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: 'page_view',
        session_id: sessionId,
        anon_id: anonId,
        path: window.location.pathname,
        referrer: document.referrer || null,
        meta: {
          page_name: pageName,
          user_agent: navigator.userAgent,
          timestamp: new Date().toISOString()
        }
      })
    }).catch(err => console.error('Tracking error:', err));
  }, []);

  // Track custom event
  const trackEvent = useCallback((eventType, metadata = {}) => {
    const sessionId = getSessionId();
    const anonId = getAnonId();
    
    fetch(`${BACKEND_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        session_id: sessionId,
        anon_id: anonId,
        path: window.location.pathname,
        referrer: document.referrer || null,
        meta: {
          ...metadata,
          timestamp: new Date().toISOString()
        }
      })
    }).catch(err => console.error('Tracking error:', err));
  }, []);

  return { trackPageView, trackEvent };
};

// Hook pour tracker automatiquement les page views
export const usePageViewTracking = (pageName) => {
  const { trackPageView } = useTracking();

  useEffect(() => {
    if (pageName) {
      trackPageView(pageName);
    }
  }, [pageName, trackPageView]);
};
